<template>
  <div class="about-us">

    <div class="container is-boxed-fluid">
      <div class="row">
        <div class="col-6 col-xs-12" v-if="page.data.extras.image_1">
          <img :src="APP_PATH + page.data.extras.image_1" alt="">
        </div>
        <div class="col-6 col-xs-12">
          <h2 class="section-title with-line" v-if="page.data.extras.title_1" v-html="page.data.extras.title_1"></h2>
          <h3 class="section-title" v-if="page.data.extras.subtitle_1" v-html="page.data.extras.subtitle_1"></h3>
          <div v-html="page.data.extras.content_1"></div>
        </div>
      </div>

      <div class="row">
        <div class="col-6 col-xs-12" v-if="page.data.extras.image_2">
          <img :src="APP_PATH + page.data.extras.image_2" alt="">
        </div>
        <div class="col-6 col-xs-12">
          <h2 class="section-title with-line" v-if="page.data.extras.title_2" v-html="page.data.extras.title_2"></h2>
          <h3 class="section-title" v-if="page.data.extras.subtitle_2" v-html="page.data.extras.subtitle_3"></h3>
          <div v-html="page.data.extras.content_2"></div>
        </div>
      </div>

      <div class="row">
        <div class="col-6 col-xs-12" v-if="page.data.extras.image_3">
          <img :src="APP_PATH + page.data.extras.image_3" alt="">
        </div>
        <div class="col-6 col-xs-12">
          <h2 class="section-title with-line" v-if="page.data.extras.title_3" v-html="page.data.extras.title_3"></h2>
          <h3 class="section-title" v-if="page.data.extras.subtitle_3" v-html="page.data.extras.subtitle_3"></h3>
          <div v-html="page.data.extras.content_3"></div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'about-us',
  i18n: {
    messages: {
      en: {
        section_1: {
          title: 'Petoor Chronology',
          content:
            'Petoor was founded in 2016 with the official launch event being held on July 16. The first collection included urban style pyjamas, which could be worn when going shopping. Lady Jazz Marine Hakobyan, one of  Armenia’s beloved  Jazz singers,  became the official face of the company.\n' +
            '\n' +
            '\n' +
            'The first boutique was founded in  2016 in “Tashir For Armenian Brands” mall. \n' +
            '\n' +
            'In 2016 - 5 Concept, the first and by now the most well known multi-brand designer boutique, was founded with Petoor being one of the 5 founding members.\n' +
            '\n' +
            'In 2017 Petoor began to offer leather accessories, most particularly, designer shoes and bags. It was at this time that Petoor was able to offer a complete wardrobe ensemble, including both clothing and accessories. \n' +
            'In 2018 Petoor released its 925 silver line.\n' +
            '\n' +
            'In 2018 Petoor also released its Petoor Body care collection which included face care products, lip balms and so on. \n' +
            '\n' +
            'During its three years of its activity, Petoor has participated in a number of exhibitions, installations and has created partnerships with other brands and designers. Petoor has also engaged in corporate identity designs and charitable initiatives.\n' +
            '\n' +
            'Today Petoor is ready to produce clothing and accessory options for the mass market with its separate Petoor silver, Petoor shoes, and Petoor body care lines.\n'
        },
        section_2: {
          title: 'Who is a Petoor Woman?',
          content:
            'In this hectic pace of life, a Petoor woman can take pauses in order to nurture her feminine beauty. The Petoor woman spreads her charm wherever she goes. It helps a woman to keep up with the latest trends and continue her education and self-development. After all, there is a time when everything retreats and yields its place to sensual ease and self-love, otherwise, it would be impossible to demand the same from the world.'
        },
        section_3: {
          title: 'Our Vision',
          content:
            'Our goal is to adhere to the Conscious Manufacturing trend. Through continuous market research and customer profiling, Petoor produces unique and elegant dresses for the confident woman.'
        },
        section_4: {
          title: 'Our Purpose',
          content:
            'Our purpose is to produce clothing that will help women embrace their femininity with fashionable, and pyjama-style dresses that are as light as a feather.'
        },
        section_5: {
          title: 'Our Belief',
          content:
            'We believe that each woman is more alluring and self-confident if she embraces her femininity.'
        },
        section_6: {
          title: 'Values',
          content:
            '<h3>Petoor DNA</h3><p>We are faithful to the Petoor style and we create clothing that is lightweight, like a feather.</p><h3>Team</h3><p>We value our team as professional. We are customer-oriented. We use data and feedback from օur customers to develop the quality of our service and product.</p><h3>Communication</h3><p>We are always open to talk to our customers and our customers share our belief and philishopy.</p>'
        },
        section_7: {
          title: 'ԳԻՏԱԿՑՎԱԾ ԱՐՏԱԴՐՈՒԹՅՈՒՆ',
          content:
            '<p>Գիտակցված սպառումն ունենալով որպես ուղենիշ՝ սեզոնից սեզոն Petoor-ի թիմը կատարում է շուկայի պահանջների, ծավալի և սպառման մանրակրկիտ ուսումնասիրություն, որի արդյունքում արտադրվում է այնքան արտադրանք, որն ամբողջությամբ, կամ համարյա ամբողջությամբ հնարավոր կլինի իրացնել՝ աշխարհի թեթև արդյունաբերության մեր ոլորտի կողմից ստեղծվող ավելցուկը չլրացնելու նպատակով:</p><p>Մենք նպատակ ունենք արտադրել այնքան արտադրանք, որն ամբողջությամբ, կամ համարյա ամբողջությամբ հնարավոր կլինի իրացնել՝ աշխարհի թեթև արդյունաբերության մեր ոլորտի կողմից ստեղծվող ավելցուկը չլրացնելու նպատակով: Մենք մշտապես ականջալուր ենք աշխարհին:</p>'
        }
      },
      hy: {
        section_1: {
          title: 'Petoor-ի մասին',
          content:
            '<p>\n' +
            '  Petoor-ը հիմնադրվել է 2016 թ.-ին, նրա գործունեության պաշտոնական մեկնարկը տրվեց հուլիսի 16-ին կայացած շնորհանդեսով: Առաջին հավաքածուն ներկայացնում էր գիշերազգեեստներ, պիժամաներ, որ կարելի է կրել առօրյա կյանքում, անգամ հանրախանութ այցելելիս: Այս և մի քանի այլ հավաքածուների համար որպես գովազդային արշավի և ֆոտոշարքերի հերոսուհի ընտրվեց Մարինե Հակոբյանը՝ հայկական ջազի լեդի Marbey-ը:\n' +
            '</p><p>\n' +
            '  Ապրանքանիշը ստեղծվեց Tashir For Armenian Brends նախագծի շրջանակներում, բայց շատ արագ անկախացավ և սկսեց վարել ավելի լայն գործունեություն:\n' +
            '</p><p>\n' +
            '  2016թ․-5Concept հայկական առաջին դիզայներական կոնցեպտուալ խանութ-սրահի բացումը։ Խանութի հինգ համամինադիրներից մեկը հանդիսացավ Petoor-ը: Խանութն այժմ էլ ամենահայտնին է հայկական մուլտիբրենդային խանութների շարքում։\n' +
            '</p><p>\n' +
            '  2017թ.-Petoor-ը կատարեց իր առաջին փորձերը կաշվե աքսեսուարների, մասնավորապես՝ կոշիկների և պայուսակների արտադրության գործում: Հաջորդիվ մի քանի սեզոնների ընթացքում Petoor-ը սպառողին առաջարկում են կնոջ զգեստապահարանի ամբողջական կապսուլա՝ հագուստ և աքսեսուարներ:\n' +
            '</p><p>\n' +
            '  2018թ.-Petoor Jewelery 925 հարգի արծաթյա զարդերի գիծ: 2018թ.-Ստեղծվեց Petoor Body Care առաջին փոքրիկ հավաքածուն, որին հաջորդեց շուրթերի բալզամների առաջարկը՝ 2018-19 թթ. ամանորյա տոներին ընդառաջ:\n' +
            '</p><p>\n' +
            '  Իր գործունեության երեք տարիների ընթացքում Petoor-ը ունեցել է մի շարք ցուցադրություններ, ինստալացիաներ և բազմաթիվ համագործակցություններ այլ բրենդերի կամ անհատ ստեղծագործողների հետ, կատարել է կորպորատիվ պատվերներ և մասնակցել բարեգործական ծրագրերի: Այսօր ապրանքանիշը շարժվում է գիտակցված սպառման ճանապարհով՝ ապահովելով արդեն ձևավորված հավատարիմ հաճախորդների պահանջմունքներին համապատասխան նորաձև, Petoor-ի ԴՆԹ-ն կրող հարմարավետ, կանացի հագուստ: Petoor-ը պատրաստ է մուտք գործել համաշխարհային դիզայնի արդյունաբերություն՝ իր առանձին Petoor silver, Petoor shoes, Petoor body care գծերով։\n' +
            '</p>'
        },
        section_2: {
          title: 'Petoor-ը կանացիություն է',
          content:
            'Խելահեղ ռիթմով ապրող աշխարհում Petoor-ի կինը կարողանում է պաուզաներ վերցնել՝ ամբողջ ուժով զգալու իր կանացիության հմայքը, ցու՛յց տալու այն, վարակելու դրանով շրջապատն ու էլէկտրականացնելու օդը իր և Նրա միջև: Թեթև ֆլիրտը երբեք չի խանգարել կնոջը լինել ամեն ինչում առաջինը, քայլել ժամանակին համընթաց, շարունակել կրթվել ու զարգանալ: Բայց կա մի ժամ, երբ ամեն ինչ նահանջում է՝ իր տեղը զիջելով զգայական թեթևությանն ու պաշտամունքի հասնող սիրուն սեփական անձի հանդեպ. այլապես անհնար կլինի պահանջել նույնը աշխարհից:'
        },
        section_3: {
          title: 'Մեր տեսլականը',
          content:
            'Մենք նպատակ ունենք արտադրել այնքան արտադրանք, որն ամբողջությամբ, կամ համարյա ամբողջությամբ հնարավոր կլինի իրացնել՝ աշխարհի թեթև արդյունաբերության մեր ոլորտի կողմից ստեղծվող ավելցուկը չլրացնելու նպատակով:'
        },
        section_4: {
          title: 'ՄԵՐ ՆՊԱՏԱԿԸ',
          content:
            'Մեր նպատակն է ստեղծել թեթև և գիշերազգեստի նուրբ ելևէջներ ունեցող հագուստ, որը կօգնի կանանց ընդգծել իրենց կանացիությունը։ Մենք ստեղծում ենք հագուստներ, որոնք փետուրի նման թեթև և եթերային են։'
        },
        section_5: {
          title: 'ՄԵՆՔ ՀԱՎԱՏՈՒՄ ԵՆՔ',
          content:
            'Մենք հավատում են, որ յուրաքանչյուր կին կարող է լինել ավելի հաջողակ և ինքնավստահ, եթե նա բացահայտի է իր կանացի յուրահատուկ գրավչությունը։'
        },
        section_6: {
          title: 'ՄԵՐ ԱՐԺԵՔՆԵՐԸ',
          content:
            '<h3>Petoor ԴՆԹ</h3><p>Մենք հավատարիմ ենք Petoor-ի ոճին և ստեղծում ենք հագուստներ, որոնք թեթև են Petoor-ի նման։</p><h3>Թիմ</h3><p>Մեզ համար կարևորը է ունենալ պրոֆեսիոնալ թիմ, որը կիսում է մեր գաղափարախոսությունը։</p><h3>Հաճախորդամետություն</h3><p>Մենք կիրառում ենք թե՛ անմիջական, և թե՛ հեռակա հարցման տեսակները մեր հաճախորդների հետ մշտական երկխոսություն պահպանելու համար։ Petoor-ը մշտապես բարելավում է իր արտադրանքի ու ծառայության որակը՝ հիմնվելով հաճախորդների կարծիքների և խորհուրդների վրա։</p>'
        },
        section_7: {
          title: 'ԳԻՏԱԿՑՎԱԾ ԱՐՏԱԴՐՈՒԹՅՈՒՆ',
          content:
            '<p>Գիտակցված սպառումն ունենալով որպես ուղենիշ՝ սեզոնից սեզոն Petoor-ի թիմը կատարում է շուկայի պահանջների, ծավալի և սպառման մանրակրկիտ ուսումնասիրություն, որի արդյունքում արտադրվում է այնքան արտադրանք, որն ամբողջությամբ, կամ համարյա ամբողջությամբ հնարավոր կլինի իրացնել՝ աշխարհի թեթև արդյունաբերության մեր ոլորտի կողմից ստեղծվող ավելցուկը չլրացնելու նպատակով:</p><p>Մենք նպատակ ունենք արտադրել այնքան արտադրանք, որն ամբողջությամբ, կամ համարյա ամբողջությամբ հնարավոր կլինի իրացնել՝ աշխարհի թեթև արդյունաբերության մեր ոլորտի կողմից ստեղծվող ավելցուկը չլրացնելու նպատակով: Մենք մշտապես ականջալուր ենք աշխարհին:</p>'
        }
      }
    }
  },
  data () {
    return {
      banner: '/img/banner_2.png'
    }
  },
  computed: mapState(['page'])
}
</script>

<style lang="scss">
.about-us {
  padding-top: 120px;
  padding-bottom: 70px;

  @include mq($ms){
    padding-top: 65px;
  }

  .container{
    .row{
      align-items: center;
      &:not(:last-child){
        margin-bottom: 30px;
      }
      &:nth-child(2n){
        .col-6{
          &:first-child{
            order: 2;
          }
          &:last-child{
            order: 1;
          }
        }
      }
      .col-6{
        img{
          width: 100%;
        }
        h3{
          margin-bottom: 40px;
        }
      }
    }
  }
}
</style>
